import moment from "moment";
import UserProductionDetail from "../UserProductionDetail";
import Location from "../../../Utility/Crud/Location";
import Term from "../../../Utility/Crud/Term";
import User from "../../../Utility/Crud/User";

export default class UserProductionDetailBrightreeInvoice extends UserProductionDetail {
    columns = [
        {
            title: "Invoice #",
            name: "brightree_invoice.id",
            type: "number",
            width: 140,
        },
        {
            title: "User",
            name: "userProfileId",
            type: "user",
            width: 200,
        },
        {
            title: "Worked At",
            name: "workedAt",
            type: "dateTime",
            width: 140,
        },
        {
            title: "Status",
            name: "brightree_invoice.brightree_invoice_status_term_id",
            type: "term",
            width: 140,
        },
        {
            title: "Followup Status",
            name: "brightree_invoice.invoice_followup_status_term_id",
            type: "number",
            width: 200,
        },
        {
            title: "Sales Location",
            name: "brightree_invoice.order_activity.sales_location_id",
            type: "location",
            width: 200,
        },
        {
            title: "Payor Name",
            name: "brightree_invoice.payor_name",
            type: "string",
            width: 180,
        },
        {
            title: "Balance",
            name: "brightree_invoice.balance",
            type: "currency",
            width: 140,
            align: "right",
        },
    ];

    /**
     * Transforms raw API response rows into a formatted rows
     * suitable for rendering in the DataGrid.
     * 
     * @param {Object[]} response - Array of raw API response rows.
     */
    handleTransformRows(response) {
        let transformedRows = [];

        response.map((row) => {
            try {
                const parsed = JSON.parse(row.jsonDetail);

                const transformRow = (item) => {
                    item.userProfileId = User.getDisplayName(this.context.usersIndexed[row.userProfileId]) || row.userProfileId;
                    item.workedAt = row.workedAt ? row.workedAt : null;

                    if (item["brightree_invoice.order_activity.sales_location_id"]) {
                        item["brightree_invoice.order_activity.sales_location_id"] =
                            Location.getDisplayName(this.context.locationsIndexed[item["brightree_invoice.order_activity.sales_location_id"]]) ||
                            item["brightree_invoice.order_activity.sales_location_id"];
                    }

                    if (item["brightree_invoice.brightree_invoice_status_term_id"]) {
                        item["brightree_invoice.brightree_invoice_status_term_id"] =
                            Term.getDisplayName(this.context.termsIndexed[item["brightree_invoice.brightree_invoice_status_term_id"]]) ||
                            item["brightree_invoice.brightree_invoice_status_term_id"];
                    }

                    if (item["brightree_invoice.invoice_followup_status_term_id"]) {
                        item["brightree_invoice.invoice_followup_status_term_id"] =
                            Term.getDisplayName(this.context.termsIndexed[item["brightree_invoice.invoice_followup_status_term_id"]]) ||
                            item["brightree_invoice.invoice_followup_status_term_id"];
                    }

                    return item;
                };

                if (Array.isArray(parsed)) {
                    transformedRows.push(...parsed.map(transformRow));
                } else {
                    transformedRows.push(transformRow(parsed));
                }
            } catch (e) {
                console.error("Failed to parse jsonDetail:", row.jsonDetail, e);
            }
        })


        this.setState({
            rows: transformedRows,
            loading: false,
            loadedAt: new Date(),
        });
    }

    /**
     * Overrides the base class's `getTitle()` method to provide a custom header title.
     * 
     * @returns {string} The header title to display: "Invoice Production".
     */
    getTitle() {
        return "Invoice Production";
    }

    /**
     * Get any applicable group summary items for the data grid. This is used to
     * add custom values to the grouping rows.
     */
    getGroupSummaryItems() {
        return [{
            columnName: "brightree_invoice.balance",
            type: "sum",
            showInGroupFooter: false,
            alignByColumn: true
        }];
    }

    /**
     * Returns the term ID representing the specific type of user production detail
     * associated with this component or subclass.
     * @returns {number} The term ID for Brightree Invoice (64).
     */
    getUserProductionDetailTypeTermId() {
        return 64;
    }

    /**
     * Returns the ordered list of column names to be used
     * in the CSV export. This determines both the column headers
     * and the order in which data is displayed in the export file.
     *
     * @returns {string[]} An array of column header names in the desired export order.
     */
    getCSVExportColumnNames() {
        return {
            "invoice production": [
                "Invoice #",
                "User",
                "Worked At",
                "Status",
                "Followup Status",
                "Sales Location",
                "Payor Name",
                "Balance"
            ],
        };;
    }
}
